












































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class RapportProg extends Vue {
    // @Prop() private title!: string;
}
